import { request } from "./request";

export const updateNotificationAPI = (notificationIdsArr) => {
  return request.post("/notifications/update", {
    ids: notificationIdsArr,
  });
};
